import { render, staticRenderFns } from "./RoleBasedAccessControlMenu.vue?vue&type=template&id=4994b889&scoped=true"
import script from "./RoleBasedAccessControlMenu.vue?vue&type=script&lang=js"
export * from "./RoleBasedAccessControlMenu.vue?vue&type=script&lang=js"
import style0 from "./RoleBasedAccessControlMenu.vue?vue&type=style&index=0&id=4994b889&prod&lang=scss"
import style1 from "./RoleBasedAccessControlMenu.vue?vue&type=style&index=1&id=4994b889&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4994b889",
  null
  
)

export default component.exports